import React, { useState,useEffect } from 'react';
import './style.scss'; // Import your CSS file with modal styles

const Modal = ({ isOpen, onClose, children,showClose=false , modalOverlayClass=""}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  
    return () => document.body.classList.remove("modal-open");
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }
  return (
    <div className={`modal-overlay ${modalOverlayClass}`}>
      <div className="modal-content text-center ">
        {showClose && <span className="close-button" onClick={onClose}>
          &times;
        </span>}
        {children}
      </div>
    </div>
  );
};

export default Modal;